export default __webpack_public_path__ + "static/media/caution-icon.808751ef.svg";